import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import { BooleanField, Labeled, ReferenceField, SimpleShowLayout, TextField } from "react-admin";

const UndergraduateData = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        spacing={2}
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="specialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Стажантски план">
            <TextField
              source="planName"
              label="Стажантски план"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Месечен стаж">
            <BooleanField source="isPlanMonthlyInternship" />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default UndergraduateData;
